import { create } from 'zustand';
import { Profile } from '@/types/profile';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface PrevUsersStore {
    prevUsers: Profile[];
    usersList: Profile[];
    setPrevUsers: (users: Profile[]) => void;
    setUserList: (users: Profile[]) => void;
}

export const userProfilesAll = create<PrevUsersStore>()(
    devtools(
        immer((set) => ({
            prevUsers: [],
            usersList: [],
            setPrevUsers: (users) => set({ prevUsers: users }),
            setUserList: (users) => set({ usersList: users }),
        })),
    ),
);
